<template>
  <div v-if="productData" :class="rootCss" :style="showCard ? 'display:block' : 'display:none'">
    <div class="row no-gutters">
      <span class="closeQuickModal" v-on:click="closeModal" v-show="modal">
        <i class="lni lni-close"></i>
      </span>
      <div class="quick-v-prod-name" v-show="showName">
        {{productData.productName}}
      </div>

      <div v-show="showImage" class="col-12 col-md-5 quick-v-thumb">
        <span class="quick-v-discount" v-show="productData.productHasDiscount"
              v-html="productData.productDisclosure"></span>
        <div class="thumbnail_container">
          <div class="thumbnail">
            <picture>
              <source media="(max-width: 270px)" :srcset="mainImage.medium">
              <img :src="mainImage.large"
                   :alt="productData.productName">
            </picture>
          </div>
        </div>
      </div>

      <div :class="showImage ? 'col-12 col-md-7 quick-v-info ' : 'col-12 quick-v-info'">
        <div class="row no-gutters">
          <div class="col-12 productDescription"
               v-show="showContent"
               v-html="productData.productDescription"
               ss-container>
          </div>
          <div class="col-6 quick-v-code" v-show="showContent">
            <span class="quick-v-code-ttl">{{ t('product_code.short') }}:</span>
            <span class="quick-v-code-id">{{productData.productId}}</span>
          </div>
          <div class="col-6 quick-v-code quick-v-barcode" v-show="showContent && productData.barCodes.length">
            <span class="quick-v-code-ttl">{{ t('product_barcode') }}:</span>
            <span class="quick-v-code-id">{{productData.barCodes[0]}}</span>
          </div>
          <div class="col-12 quick-v-price-row" v-show="showContent">
            <div class="row">
              <span v-show="productData.productHasDiscount" class="col-4 col-sm-3 quick-v-og-price">
                <span v-html="priceWithSign(productData.productOldPrice, getSign())"></span>
              </span>
              <span v-show="productData.productHasDiscount" class="col-5 col-sm-5 quick-v-save">
                <span class="quick-v-save-ttl">{{ t('you_earn') }}</span>
                <span class="quick-v-save-amount" v-html="priceWithSign(diffStringPrices(productData.productOldPrice, productData.productFinalPrice), getSign())"></span>
              </span>

              <span class="col-3 col-sm-4 quick-v-price" v-html="priceWithSign(productData.productFinalPrice, getSign())">
              </span>
            </div>
          </div>

          <!-- Attributes -->
          <attribute-select
            v-if="hasAttributes"
            v-on:matched-product-code="codeIdChanged"
            v-on:product-attribute-selected="attributeSelected"
            :product-id="productId"></attribute-select>

          <variation-select
            v-if="hasVariationEntries && variationsActive"
            :product-id="productId">
          </variation-select>

          <div v-if="this.productData.vendorName !== this.vendor" class="col-12 add-cart">
            <div class="col-12 quick-v-quantity quick-v-unavailable"
                 v-if="productCodeId && (inactiveProduct || unavailableProduct)">
            <span v-show="inactiveProduct && config.showInactiveProductCodes">
              {{ t('product_status.unavailable') }}
            </span>
              <span v-show="unavailableProduct && !inactiveProduct">
              {{ t('product_status.unavailable.out_of_stock') }}
            </span>
            </div>
            <!-- Qty-->
            <div
              class="col-12 col-sm-6 quick-v-quantity"
              v-else>
              <adv-product-input-spinner
                :product-code-id="productCodeId"
                :watch-for-product-code-id-changes="false"
                :max-amount="maxAmountForInputSpinner"
                v-bind:quantity="quantity"
                v-on:quantity-changed="quantityChanged"></adv-product-input-spinner>
            </div>
            <!-- Btn-->
            <div class="col-12 col-sm-6 quick-v-tocart">
              <adv-cart-button
                class="addToCart"
                :unavailable="unavailableProduct || cartLimitForProductReached"
                :cart-limit-reached="cartLimitForProductReached"
                :has-attributes="hasAttributes"
                :selected-attribute-id="selectedAttributeId"
                v-on:btn-click="addToCard"
                :stock="productCodeData.productStock"
                :progress="progress"
                :productId="this.productId"
                v-bind:quantity="quantity"></adv-cart-button>
            </div>
          </div>
          <div class="col-12" v-else>
            <div class="col-12 quick-v-unavailable"
                 v-if="productCodeId && (inactiveProduct || unavailableProduct)">
            <span v-show="inactiveProduct && config.showInactiveProductCodes">
              {{ t('product_status.unavailable') }}
            </span>
              <span v-show="unavailableProduct && !inactiveProduct">
              {{ t('product_status.unavailable.out_of_stock') }}
            </span>
            </div>
            <div v-else>
              <a :href="'tel:' + t('site.phone')" class="btn btn-dark">{{t('available.at_store_btn')}}</a><br/>
              <span>{{t('call_us_at')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { some } from 'lodash'
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import AttributeSelect from './attributes/AttributeSelect'
import AdvCartButton from './AdvCartButton'
import AdvProductInputSpinner from './AdvProductInputSpinner'
import VariationSelect from './variations/VariationSelect'

export default {
  name: 'AdvProductCard',
  components: {
    AttributeSelect,
    VariationSelect,
    AdvCartButton,
    AdvProductInputSpinner
  },
  props: {
    productId: {
      type: Number
    },
    showName: {
      type: Boolean,
      default: false
    },
    showContent: {
      type: Boolean,
      default: false
    },
    showImage: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    }
  },
  mixins: [productMixin],
  data () {
    return {
      version: '0.0.2',
      productCodeId: null,
      quantity: 1,
      showCard: true,
      mainImage: {
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      },
      vendor: 'Matis Paris'
    }
  },
  mounted () {
    this.setProductCodeIdForOneOnOne()
    this.setMainImage()
  },
  watch: {
    productId () {
      this.setProductCodeIdForOneOnOne()
      this.setMainImage()
    }
  },
  computed: {
    progress: {
      get () {
        return store.getters.getAddToCartComboClicked
      },
      set (value) { store.commit('setAddToCartComboClicked', value) }
    },
    rootCss () {
      if (this.modal) {
        return 'modalQuickV'
      }
      return ''
    },
    config () {
      return store.getters.config
    },
    hasAttributes () {
      return some(this.productData.productCodes, (e) => {
        return e.productCodeAttributes.length > 0
      })
    },
    hasVariationEntries () {
      return this.$store.getters.getUniqueProductVariationValueIds.length > 0
    },
    productPriceClass () {
      return 'col-xs-12 ' + (this.productData.productFinalPrice === this.productData.productOldPrice ? '' : 'col-sm-4 ') + 'text-right productItemMainPrice'
    },
    listImage () {
      return this.productData ? this.productData.productImage.list : store.getters.noImage
    },
    inactiveProduct () {
      return !this.productCodeData.productActive
    },
    unavailableProduct () {
      return this.productCodeData.productStock <= 0 || this.productData.productFinalPrice <= 0
    },
    cartLimitForProductReached () {
      return this.productCodeData.productStock === this.cartQuantity
    },
    selectedAttributeId () {
      return parseFloat(store.getters.getSelectedAttributeId)
    },
    cartQuantity () {
      return this.$store.getters.cartProductCodeQuantity(this.productCodeId, 0)
    },
    maxAmountForInputSpinner () {
      return this.productCodeData.productStock - this.cartQuantity
    },
    variationsActive () {
      return store.getters.getVariationsActive
    }
  },
  methods: {
    setProductCodeIdForOneOnOne () {
      if (!this.hasAttributes) {
        this.codeIdChanged(this.productData.productCodes[0].productCodeId)
        return
      }

      this.quantity = 1
    },
    closeModal () {
      this.showCard = false
      this.$emit('close-quick-view')
      this.clearSelectedAttributeId()
    },
    clearSelectedAttributeId () {
      if (this.hasAttributes) {
        store.state.selectedAttributeId = null
      }
    },
    priceWithSign (priceString, priceSign) {
      return (parseFloat(priceString) * store.getters.getSelectedCurrency.rate).toFixed(2) + priceSign
    },
    getSign () {
      return store.getters.getSelectedCurrency.symbol
    },
    diffStringPrices (priceA, priceB) {
      return (parseFloat(priceA) - parseFloat(priceB)).toFixed(2).toString()
    },
    attributeSelected (attributeId) {
      store.dispatch('setSelectedAttributeId', attributeId)
    },
    codeIdChanged (productCodeId) {
      this.productCodeId = productCodeId
      if (this.productCodeId) {
        store.dispatch('setSelectedProductCodeId', this.productCodeId)
        this.setMainImage()
      }
    },
    quantityChanged (quantity) {
      this.quantity = quantity
    },
    addToCard () {
      this.progress = true
      store.dispatch('addToCartClicked', {
        productCodeId: this.productCodeId,
        quantity: this.cartQuantity + this.quantity
      })
        .then(() => {
          this.progress = false
          this.quantity = 1
        })
    },
    setMainImage () {
      if (this.productCodeId) {
        this.mainImage = this.productData.images[this.productCodeId].find(image => image.is_main === '1')
      } else {
        this.mainImage = this.productData.images[parseInt(Object.keys(this.productData.images)[0])].find(image => image.is_main === '1')
      }
    }
  }
}
</script>
